<template>
  <div class="card bg-lightgray">
    <div class="card-content">
      <div class="media h-full">
        <div
          v-if="imageUrl"
          class="media-left"
        >
          <img
            :src="imageUrl"
            :alt="imageAlt"
            width="150"
          >
        </div>
        <div class="media-content">
          <p class="title is-6">
            {{ cardTitle }}
            <small
              v-if="smallTitle"
              class="has-text-success"
            >
              {{ smallTitle }}
            </small>
          </p>
          <div class="columns is-desktop">
            <div class="flex h-full justify-between column">
              <p class="text-xs has-text-grey">
                <ol>
                  <li
                    v-for="(textline, index) in textLines"
                    :key="index"
                    :class="textline.class"
                  >
                    {{ textline.text }}
                  </li>
                </ol>
              </p>
              <slot />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseCardWithImage',
  props: {
    imageUrl: {
      type: String,
      default: 'https://via.placeholder.com/150',
    },
    imageAlt: {
      type: String,
      default: undefined,
    },
    cardTitle: {
      type: String,
      required: true,
    },
    smallTitle: {
      type: String,
      default: '',
    },
    textLines: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
